import { useCallback } from "react";
import { isOrganizationAdmin } from "@gettactic/helpers/src/features/isOrganizationAdmin";
import { useAuthenticated } from "./authenticated/useAuthenticated";

type UseIsPrivacyEnabledProps = {
  enablePrivacyMode: boolean;
  privacyModeOffices: string[];
};

export const useIsPrivacyEnabled = ({
  enablePrivacyMode,
  privacyModeOffices
}: UseIsPrivacyEnabledProps) => {
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();
  const isNotAdmin = !isOrganizationAdmin(authenticatedUser);

  return useCallback(
    (officeId: string | undefined) => {
      if (!enablePrivacyMode || !isNotAdmin) {
        return false;
      }
      if (privacyModeOffices.length === 0) {
        return true;
      }
      return officeId ? privacyModeOffices.includes(officeId) : false;
    },
    [enablePrivacyMode, privacyModeOffices, isNotAdmin]
  );
};
